import {css} from '@emotion/css';
import React from 'react';
import {Block} from './Block';
import {Button} from './Button';
import {
  SocialMediaPublicReviewMetricName,
  getMarketGoogleReviewLink,
  getMarketNextdoorReviewLink,
  getMarketYelpReviewLink,
  getTrackUrl,
  theme,
} from './Common';

export type PublicReviewButtonsProps = {
  encryptedId: Maybe<string>;
  market: Maybe<string>;
};

export function PublicReviewButtons({encryptedId, market}: PublicReviewButtonsProps) {
  return (
    <Block
      className={css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        flexWrap: 'wrap',
        margin: `${theme.spacings.small} 0`,
      })}
    >
      <Button
        buttonStyle='secondary'
        as='a'
        target='_blank'
        href={getTrackUrl({
          url: getMarketYelpReviewLink(market),
          args: {
            pickup: {encrypted_id: encryptedId},
            metricName: SocialMediaPublicReviewMetricName.YELP,
          },
        })}
      >
        Add Yelp review
      </Button>
      <Button
        buttonStyle='secondary'
        as='a'
        target='_blank'
        href={getTrackUrl({
          url: getMarketGoogleReviewLink(market),
          args: {
            pickup: {encrypted_id: encryptedId},
            metricName: SocialMediaPublicReviewMetricName.GOOGLE,
          },
        })}
      >
        Add Google review
      </Button>
      <Button
        buttonStyle='secondary'
        as='a'
        target='_blank'
        href={getTrackUrl({
          url: getMarketNextdoorReviewLink(market),
          args: {
            pickup: {encrypted_id: encryptedId},
            metricName: SocialMediaPublicReviewMetricName.NEXTDOOR,
          },
        })}
      >
        Add Nextdoor review
      </Button>
    </Block>
  );
}
